const truncate = (text: string, limit = 188) => {
  if (!text) return;

  return text?.length > limit
    ? text?.substring(0, limit - 3) + '...'
    : text;
};

export default truncate;
